<template>
    <div id="message-send">
        <div class="content">
            <el-row :gutter="30" >
                <el-col 
                    :md="{span: 24, offset: 0}"
                    :lg="{span: 16, offset: 0}" 
                    :xl="{span: 10, offset: 0}"

                >
                    <div class="left">
                        <el-form ref="form" :rules="rules" :model="form" label-width="100px" >
                            <el-form-item label="短信模版" prop="template">
                                <el-input v-model="form.template" placeholder="请输入短信模版"></el-input>
                            </el-form-item>
                            <el-form-item label="短信签名" prop="sign_name" >
                                <el-select v-model="form.sign_name" placeholder="请选择短信签名">
                                <el-option label="好生涯早规划" value="好生涯早规划"></el-option>
                                <el-option label="盐城市学业与职业规划学会" value="盐城市学业与职业规划学会"></el-option>
                                </el-select>
                            </el-form-item>
                           
                            <el-form-item label="是否含有变量" class="variable">
                                <el-row>
                                    <el-col :span="12" >
                                        <el-switch v-model="form.hasVariable" prop="hasVariable" ></el-switch>
                                    </el-col>
                                    <el-col :span="12" class="add">
                                        <el-button v-if="form.hasVariable" type='info' round size="mini" @click="addDomain" >添加变量</el-button>

                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <template v-if="form.hasVariable">
                                <el-form-item 
                                    v-for="(data, index) in form.data"
                                    :label="'变量' + index"
                                    :key="index"
                                    :prop="'data.' + index + '.value'"
                                    :rules="{
                                                required: true, message: '请输入变量相关信息', trigger: 'blur'
                                            }"
                                >
                                    <el-row>
                                        <el-col :span="4" >
                                            <el-form-item >
                                                <el-input v-model="data.key"  placeholder="变量"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="16">
                                            <el-form-item>
                                                <el-input v-model="data.value"  placeholder="值"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="4">
                                        <el-button @click.prevent="removeDomain(data)" >
                                            删除
                                        </el-button>
                                        </el-col>

                                    </el-row>
                                </el-form-item>
                            </template>
                            <el-form-item label="电话号码"  prop="phone">
                                <el-input type="textarea"  :rows="4" v-model="form.phone" placeholder="请输入电话号码，多条号码以英文,分号隔开，例： 18502121111,18502122222"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-upload
                                    class="upload-demo"
                                    :action="phoneUpload.action"
                                    :headers="phoneUpload.headers"
                                    multiple
                                    :limit="1"
                                    :on-success="handleSuccess"
                                    :on-remove="handleRemove"
                                    :on-error="handleError"
                                    :file-list="fileList">
                                    <el-button size="small" type="success">
                                        <i class="el-icon-upload"></i> 批量导入
                                    </el-button>
                                    <span slot="tip" class="el-upload__tip" style="margin-left:20px;">只能上传xls/xlsx/csv文件，且不手机号码不超过1000条</span>
                                </el-upload>
                            </el-form-item>
                            <el-form-item >
                                <el-button 
                                    type="primary" 
                                    @click="submitForm('form')"
                                    >
                                    立即发送
                                </el-button>
                                <el-button type="info" @click="resetForm('form')">预览</el-button>
                                <el-button @click="resetForm('form')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
                <!-- <el-col :span="6" :lg="{span: 10, offset: 0}" :xl="{span: 6, offset: 0}">
                    <div class="right">
                        ddddd
                    </div>
                </el-col> -->
                

            </el-row>
        </div>
    </div>
</template>
<script>
import requestMixin from '../../mixins/request'
import commonMixin from '../../mixins/common'
import apis from '../../env/apis'
import { getCookie } from '../../env/util'

export default {
    mixins : [requestMixin, commonMixin],
    data(){
        return {
            form: {
                template: '',
                data: [],
                sign_name: '',
                phone:'',
                hasVariable : false,
                fullscreenLoading : false
            },
            rules: {
                template: [
                    { required: true, message: '请输入短信模版', trigger: 'blur' },
                ],
                sign_name: [
                    { required: true, message: '请选择短信签名', trigger: 'change' }
                ],
                phone: [
                    { required: true, message: '请输入电话号码', trigger: 'change' }
                ],
                key: [
                    { required: true, message: '请输入变量', trigger: 'blur' },
                ],
                value: [
                    { required: true, message: '请输入变量值', trigger: 'blur' },
                ],
            },
            fileList : [],
            phoneUpload:{
                action : apis.excelImport,
                headers : {
                    Authorization : `Bearer ${getCookie('access_token')}`,
                    // 'content-type': 'application/json'
                },
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$confirm('短信发送操作一旦发送不可取消, 是否继续?', '提示', {
                        confirmButtonText: '确定发送',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let variable = this.form.hasVariable == true ? this.form.data : [];
                        this.sendMessage(this.form.phone, this.form.sign_name, this.form.template, variable);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消发送'
                        });          
                    });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        addDomain() {
            this.form.data.push({
                key: '',
                value: '',
            });
        },
        removeDomain(item) {
            var index = this.form.data.indexOf(item)
            if (index !== -1) {
                this.form.data.splice(index, 1)
            }
        },
        handleSuccess(v){
            if( v.status == 'success' ){
                this.form.phone = v.data.list;
            }else{
                this.$message({
                    showClose: true,
                    message: v.errmsg,
                    type: 'warning'
                });
            }
        },
        handleError(err,file,fileList){
            this.$message({
                showClose: true,
                message: err,
                type: 'warning'
            });
        },
        handleRemove(v){
            this.form.phone = '';
        }
    }
}
</script>
<style lang="less">
    @bgColor : white;
    #message-send{
        .content{
            font-family: "Hiragino Sans GB",Helvetica;
            .left, .right{
                background: @bgColor;
                padding: 20px 0;
            };
            .left{
                .el-select{
                    width:100%;
                }
                .variable{
                    .add{
                        text-align:right;
                    }
                }
                
            }
        }
    
    }
</style>